import type { JurisdictionValueDto } from '../types';

const STATUS_LABEL: Record<JurisdictionValueDto['status'], string> = {
  Verified: '',
  Unknown: 'Unknown',
  PendingReview: 'Pending review',
  NotApplicable: 'N/A',
};

/** A jurisdiction value from the server. A value is shown only when it is Verified; otherwise the honest status (Unknown, Pending review, N/A) is shown, muted. */
export function JurisdictionValue({ item, testId }: { item: JurisdictionValueDto; testId?: string }) {
  const verified = item.status === 'Verified' && item.value;
  return (
    <span className={`eo-jv${verified ? '' : ' eo-jv--muted'}`} data-status={item.status} {...(testId ? { 'data-testid': testId } : {})}>
      {verified ? item.value : STATUS_LABEL[item.status]}
    </span>
  );
}
